import type { FaireThemeEntity } from "../../entity_types/theme";

export const board_demo_r_wd64rb2zkz_hero_mothers_day_refined_1: FaireThemeEntity =
  {
    token: "board_demo_r_wd64rb2zkz_hero_mothers_day_refined_1",
    type: "theme",
    retailerToken: "r_wd64rb2zkz",
    name: "Mother's Day picks",
    description:
      "Twenty-eight picks for your faith-forward baby and gift boutique in Iowa Falls. Mama keepsake jewelry, devotional books for new moms, organic bath sets for postpartum care, and warm apparel your regulars already reorder, all priced so gift-givers can pick up two without thinking.",
    bgColor: "#F5D4E8",
    productTokens: [
      "p_sgaaaufprg",
      "p_vzv2may7uc",
      "p_4dbkfhukh2",
      "p_zdu7pbb9dc",
      "p_hg354pg9y5",
      "p_fpngcgaf42",
      "p_dahj7tn45p",
      "p_4wqzuye8af",
      "p_jgdhwv9hr2",
      "p_bze2zrj7pp",
      "p_a2qhezjz5e",
      "p_x6sfeubfmz",
      "p_snqggxjskf",
      "p_xvrxrhjwyz",
      "p_xsrxbhpwqa",
      "p_4hzhzrqck3",
      "p_y292sn6s37",
      "p_d52s2gk72u",
      "p_8ghtfvnbnx",
      "p_njpp5nt5uw",
    ],
    coverImageUrl:
      "https://cdn.faire.com/fastly/c0225365f255368877edb1aeb9b8d02571ef3586127428f1819a6855338d4344.jpeg",
    thumbnailImageUrls: [
      "https://cdn.faire.com/fastly/c0225365f255368877edb1aeb9b8d02571ef3586127428f1819a6855338d4344.jpeg",
      "https://cdn.faire.com/fastly/2a9bc88c06d0adecafc6c263a548a2efd8af2c76661755c65710ef555f0e4a88.jpeg",
      "https://cdn.faire.com/fastly/627a3b4a370d0c24ca95460e2517e43d64bc445036c2854834d4ab7f45b727e7.jpeg",
      "https://cdn.faire.com/fastly/1970eb4f9125ea944df70bf54af5c3cbb4e935abc708efa56025f517e2935090.jpeg",
      "https://cdn.faire.com/fastly/2417eb372a09dd5417db338863a6504f32d8b9093e0766a0add582fad13abefb.jpeg",
      "https://cdn.faire.com/fastly/4228ca63d948a46f4a2c227e5bc86ac8c2e8c55c9ff73ba0f9b459ae044a70b3.jpeg",
    ],
    itemCount: 28,
    source: "curated_md_hero_refined_1",
    teaser: "mothers-day-picks",
    meta: {
      source: "mock",
      importedAt: "2026-04-19T23:00:00.000Z",
      importedBy: "board-demo-canonicalize",
    },
  };
